import React from 'react';
import { FiMail, FiPhone, FiMapPin, FiClock } from 'react-icons/fi';
import ApplicationForm from '../components/ApplicationForm';

export default function ContactPage() {
  return (
    <div style={{ paddingTop: 70 }}>
      <style>{`
        .contact-hero { background: linear-gradient(135deg, #0f172a, #1e3a5f); padding: 56px 0; text-align: center; }
        .contact-hero h1 { color: white; font-size: clamp(26px, 4vw, 40px); margin-bottom: 10px; }
        .contact-hero p { color: #94a3b8; }
        .contact-layout { max-width: 1100px; margin: 0 auto; padding: 56px 24px; display: grid; grid-template-columns: 1fr 1.4fr; gap: 48px; }
        .contact-info { }
        .contact-info h2 { font-size: 24px; margin-bottom: 10px; }
        .contact-info p { color: var(--mid); margin-bottom: 32px; line-height: 1.7; }
        .contact-item { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 20px; padding: 16px; background: var(--bg); border-radius: var(--radius-lg); border: 1px solid var(--border); }
        .contact-icon { width: 44px; height: 44px; border-radius: var(--radius); background: var(--primary-light); color: var(--primary); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .contact-item-label { font-size: 12px; color: var(--mid); margin-bottom: 2px; font-weight: 500; }
        .contact-item-value { font-weight: 600; font-size: 15px; }
        .contact-form-card { background: white; border-radius: var(--radius-xl); padding: 36px; box-shadow: var(--shadow-md); border: 1px solid var(--border); }
        @media (max-width: 800px) { .contact-layout { grid-template-columns: 1fr; } }
      `}</style>

      <div className="contact-hero">
        <div className="section-label" style={{ background: 'rgba(26,86,219,0.2)', color: '#93c5fd', margin: '0 auto 14px' }}>Get In Touch</div>
        <h1>We'd Love to Hear From You</h1>
        <p>Have questions about our programs? Reach out and we'll get back within 24 hours.</p>
      </div>

      <div className="contact-layout">
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>Whether you have questions about our programs, fees, or just want to chat about your career goals — we're here to help.</p>

          {[
            { icon: <FiMail size={20} />, label: 'Email Us', value: 'hello@korpnex.online' },
            { icon: <FiPhone size={20} />, label: 'Call / WhatsApp', value: '+91 98765 43210' },
            { icon: <FiMapPin size={20} />, label: 'Our Location', value: 'Bengaluru, Karnataka, India' },
            { icon: <FiClock size={20} />, label: 'Working Hours', value: 'Mon–Sat, 10 AM – 7 PM IST' },
          ].map((item, i) => (
            <div key={i} className="contact-item">
              <div className="contact-icon">{item.icon}</div>
              <div>
                <div className="contact-item-label">{item.label}</div>
                <div className="contact-item-value">{item.value}</div>
              </div>
            </div>
          ))}

          <div style={{ marginTop: 24, padding: '20px', background: 'linear-gradient(135deg, #f0f4ff, #fafbff)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)' }}>
            <h4 style={{ marginBottom: 8 }}>💬 Quick Response Guaranteed</h4>
            <p style={{ fontSize: 14, color: 'var(--mid)', lineHeight: 1.6 }}>
              We typically respond to all inquiries within 2–4 hours during business hours. For urgent matters, WhatsApp is your best bet!
            </p>
          </div>
        </div>

        <div className="contact-form-card">
          <h2 style={{ marginBottom: 6 }}>Apply or Ask a Question</h2>
          <p style={{ color: 'var(--mid)', fontSize: 14, marginBottom: 28 }}>Use this form to apply for a program or ask us anything — we'll respond quickly!</p>
          <ApplicationForm />
        </div>
      </div>
    </div>
  );
}
